// ============================================================
// KATEQORİYALARIN YEGANƏ MƏNBƏYİ
// ------------------------------------------------------------
// Bazaya (PostgreSQL) YALNIZ `id` yazılır — məs. "donlar".
// Ekranda isə cari dilə uyğun `label` göstərilir.
//
// Ona görə: adı istənilən dildə dəyişsən, bazada heç nə pozulmur.
// Yalnız burada bir sətir dəyişirsən, hər yerdə tətbiq olunur.
// ============================================================

export const CATEGORY_GROUPS = [
  {
    id: 'geyim',
    label: { az: 'GEYİM', en: 'CLOTHING', ru: 'ОДЕЖДА', tr: 'GİYİM' },
    items: [
      {
        id: 'donlar',
        label: { az: 'Donlar', en: 'Dresses', ru: 'Платья', tr: 'Elbiseler' },
      },
      {
        id: 'kostyumlar',
        label: { az: 'Kostyumlar', en: 'Suits & Sets', ru: 'Костюмы', tr: 'Takımlar' },
      },
      {
        id: 'yubkalar',
        label: { az: 'Yubkalar', en: 'Skirts', ru: 'Юбки', tr: 'Etekler' },
      },
      {
        id: 'pencekler',
        label: { az: 'Pencəklər', en: 'Blazers', ru: 'Пиджаки', tr: 'Ceketler' },
      },
      {
        id: 'koynekler-bluzlar',
        label: {
          az: 'Köynəklər və Bluzlar',
          en: 'Shirts & Blouses',
          ru: 'Рубашки и блузы',
          tr: 'Gömlek ve Bluzlar',
        },
      },
      {
        id: 'tshirt-maykalar',
        label: {
          az: 'T-shirt və Maykalar',
          en: 'T-shirts & Tops',
          ru: 'Футболки и топы',
          tr: 'Tişört ve Atletler',
        },
      },
      {
        id: 'sviter-kardiqanlar',
        label: {
          az: 'Sviter və Kardiqanlar',
          en: 'Sweaters & Cardigans',
          ru: 'Свитеры и кардиганы',
          tr: 'Kazak ve Hırkalar',
        },
      },
      {
        id: 'palto-kurtkalar',
        label: {
          az: 'Palto və Kurtkalar',
          en: 'Coats & Jackets',
          ru: 'Пальто и куртки',
          tr: 'Palto ve Montlar',
        },
      },
      {
        id: 'xudi-svitsotlar',
        label: {
          az: 'Xudi və Svitşotlar',
          en: 'Hoodies & Sweatshirts',
          ru: 'Худи и свитшоты',
          tr: 'Kapüşonlu ve Sweatshirtler',
        },
      },
    ],
  },
  {
    id: 'aksesuar',
    label: { az: 'AKSESUAR', en: 'ACCESSORIES', ru: 'АКСЕССУАРЫ', tr: 'AKSESUAR' },
    items: [
      {
        id: 'cantalar',
        label: { az: 'Çantalar', en: 'Bags', ru: 'Сумки', tr: 'Çantalar' },
      },
      {
        id: 'kemerler',
        label: { az: 'Kəmərlər', en: 'Belts', ru: 'Ремни', tr: 'Kemerler' },
      },
      {
        id: 'serfler-yayliqlar',
        label: {
          az: 'Şərflər və Yaylıqlar',
          en: 'Scarves & Shawls',
          ru: 'Шарфы и платки',
          tr: 'Eşarp ve Fularlar',
        },
      },
      {
        id: 'zergerlik',
        label: {
          az: 'Zərgərlik və Bijuteriya',
          en: 'Jewellery',
          ru: 'Украшения',
          tr: 'Takı ve Bijuteri',
        },
      },
      {
        id: 'gun-eynekleri',
        label: {
          az: 'Gün eynəkləri',
          en: 'Sunglasses',
          ru: 'Солнцезащитные очки',
          tr: 'Güneş Gözlükleri',
        },
      },
      {
        id: 'sapkalar',
        label: {
          az: 'Şapka və Papaqlar',
          en: 'Hats & Caps',
          ru: 'Головные уборы',
          tr: 'Şapka ve Bereler',
        },
      },
      {
        id: 'sac-aksesuarlari',
        label: {
          az: 'Saç aksesuarları',
          en: 'Hair Accessories',
          ru: 'Аксессуары для волос',
          tr: 'Saç Aksesuarları',
        },
      },
    ],
  },
];

export const ALL_CATEGORY = {
  id: 'all',
  label: {
    az: 'Bütün Kateqoriyalar',
    en: 'All Categories',
    ru: 'Все категории',
    tr: 'Tüm Kategoriler',
  },
};

/** Qrupsuz, düz siyahı. */
export const FLAT_CATEGORIES = CATEGORY_GROUPS.flatMap((g) => g.items);

/** id -> həmin dildəki etiket. Tapılmasa id-nin özünü qaytarır. */
export const getCategoryLabel = (id, lang = 'az') => {
  if (!id || id === 'all') {
    return ALL_CATEGORY.label[lang] || ALL_CATEGORY.label.az;
  }
  const found = FLAT_CATEGORIES.find((c) => c.id === id);
  if (found) return found.label[lang] || found.label.az;
  return id;
};

/**
 * Bazadakı köhnə məhsullar kateqoriyanı Azərbaycan MƏTNİ kimi saxlayır
 * (məs. "Donlar", "Köynəklər və Bluzlar"). Bu funksiya onu id-yə çevirir,
 * beləliklə köhnə məhsullar da filtrdə düzgün görünür və bazada
 * heç bir migrasiya etmək lazım gəlmir.
 */
export const normalizeCategory = (value) => {
  if (!value) return '';
  const raw = String(value).trim();

  // Artıq id formatındadırsa, olduğu kimi qaytar
  if (FLAT_CATEGORIES.some((c) => c.id === raw)) return raw;

  const lower = raw.toLowerCase();

  // İstənilən dildəki etiketə görə uyğunluq axtar
  const byLabel = FLAT_CATEGORIES.find((c) =>
    Object.values(c.label).some((l) => l.toLowerCase() === lower)
  );
  if (byLabel) return byLabel.id;

  // Köhnə, artıq mövcud olmayan adlar üçün əl ilə uyğunluq
  const legacy = {
    'kofta və bluzlar': 'koynekler-bluzlar',
    'mayka və t-shirt-lər': 'tshirt-maykalar',
    'pencək və jaketlər': 'pencekler',
    'xudi və sfitoşotlar': 'xudi-svitsotlar',
    'zərgərlik və bijuiteriya': 'zergerlik',
  };
  if (legacy[lower]) return legacy[lower];

  return lower;
};

export default CATEGORY_GROUPS;
